import { Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Home } from "@/pages/Home";
import { Setup } from "@/pages/Setup";
import { Releases } from "@/pages/Releases";
import { ReleaseDetail } from "@/pages/ReleaseDetail";
import { Devices } from "@/pages/Devices";

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route
          path="setup"
          element={
            <ProtectedRoute>
              <Setup />
            </ProtectedRoute>
          }
        />
        <Route path="releases" element={<Releases />} />
        {/*
         * Primary bundle detail route. Legacy `/releases/:version` (no
         * channel) still resolves — ReleaseDetail falls back to scanning
         * the full index when the channel segment is missing.
         */}
        <Route path="releases/:channel/:version" element={<ReleaseDetail />} />
        <Route path="releases/:version" element={<ReleaseDetail />} />
        <Route
          path="devices"
          element={
            <ProtectedRoute>
              <Devices />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}
